import { useSelector, shallowEqual } from 'react-redux'

export const useManagementStoreValues = () => {
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const intakeFormsLoading = useSelector((state) => state.intakeForms.loading)
  // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
  const adminProfile = useSelector((state) => state.accountSettings.adminProfile)

  const managementValues = useSelector(
    (state) => ({
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      loading: state.management.loading,
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      error: state.management.error,
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      serviceTypes: state.management.serviceTypes,
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      tabs: state.management.tabs,
    }),
    shallowEqual,
  )

  return {
    intakeFormsLoading,
    adminProfile,
    ...managementValues,
  }
}
